<template>
	<div class="footer">
		<div class="nums">
			<p>互联网药品信息服务资格证书：(粤)-经营性-2021-0467</p>
			<a href="https://beian.miit.gov.cn/">ICP备案号：粤ICP备2021111919号</a>
			<p>版权所有深圳市粤智康科技有限公司</p>
			<p>特别声明：本站信息仅供参考_不能作为诊断及医疗的依据 ┊ 本站如有转载或引用文章涉及版权问题_请速与我们联系</p>
		</div>
		<div class="erweima">
			<!-- <div> -->
				<!-- <img :src="list.qrcode" alt=""> -->
				<!-- <span>公众号二维码</span> -->
			<!-- </div> -->
			
			<div>
				<span>深圳市粤智康科技有限公司</span>
				<span>地址：深圳市宝安区西乡街道渔业社区名优采购中心B座1区101</span>
				<span>联系电话：0755-23149439</span>
			</div>
			
		</div>
	</div>
</template>

<script>
	// 引入axios
	import axios from 'axios';
	// 引入端口配置文件
	import API_LIST from '@/list.config.js';
	import {
		ElMessageBox,
		ElMessage
	} from 'element-plus'
	import qs from 'qs'
	export default {
	
		name: "Zi",
		props: {
	
		},
		data() {
			return {
				list: [],
				listData: [],
				nav_id: '',
				page: 1,
				chooseId: 0,
				show: false,
				counts: 0, // 页数
				ind: 0,
				num: 0,
				hidden: true,
			}
	
		},
		watch: {
			
		},
		computed: {
	
		},
	
		created() {
			const that = this;
			
			axios.post(API_LIST.footer, {
					
				}, {
					headers: {
						// 'Content-Type': 'application/x-www-form-urlencoded'
						'Content-Type': 'application/json'
					} //加上这个x
				})
				.then(_d => {
					console.log(_d.data)
					if (_d.data.status == 200) {
						that.list = _d.data.list;
					} else if (_d.data.status == 409) {
	
					}
	
	
				})
				.catch(function(error) {
					console.log(error);
				});
		},
		mounted() {
	
		},
	
		methods: {
			
		},
	}
	
</script>

<style scoped="scoped" lang="scss">
	.footer{
		margin: 50px 0 0 0;
		background-color: #2E2E2E;
		height: 131px;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;
		padding: 0 0 20px 0;
		.nums{
			
			p{
				color: #fff;
				margin: 10px 0;
			}
			a{
				color: #fff;
				margin: 10px 0;
			}
		}
		.erweima{
			display: flex;
			flex-direction: row;
			div{
				display: flex;
				flex-direction: column;
			}
			img{
				width: 84px;
				height: 84px;
				margin: 0 20px 0 0;
			}
			span{
				color: #fff;
				margin: 5px 0;
			}
		}
	}
</style>
